import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=5fbd2e4d&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=5fbd2e4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd2e4d",
  null
  
)

export default component.exports